export default __webpack_public_path__ + "static/media/3611.698c70d2.png";